import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";

export interface ListingAlertTemplate {
  id: number;
  name: string;
  query: Record<string, unknown>;
  createdAt: string;
  updatedAt: string;
  createdByAvatarUrl?: string | null;
  createdByName?: string | null;
  updatedByAvatarUrl?: string | null;
  updatedByName?: string | null;
  canWrite: boolean;
}

export interface ServiceError {
  error?: string;
}

const createError = (e: unknown): ServiceError => {
  const response = (e as { response?: { data?: { error?: string } } })?.response;
  const error = response ? response.data?.error : "Something went wrong!";

  return { error };
};

export const getTemplates = async ({ search }: { search?: string } = {}): Promise<
  ListingAlertTemplate[] | ServiceError
> => {
  try {
    const response = await caseTransformingAxios.get<ListingAlertTemplate[]>(
      "/listing_alert_templates.json",
      {
        params: { search },
      },
    );

    return response.data;
  } catch (e) {
    return createError(e);
  }
};

export interface ListingAlertSettings {
  personId: number | null;
  geoCodeAccountAddress: string | null;
  mlsIds: (number | string)[];
  unavailable: boolean;
}

export const getSettings = async (): Promise<ListingAlertSettings> => {
  try {
    const response = await caseTransformingAxios.get<ListingAlertSettings>(
      "/listing_alert_templates/settings.json",
    );

    return response.data;
  } catch {
    return { personId: null, geoCodeAccountAddress: null, mlsIds: [], unavailable: true };
  }
};

const preserveCaseConfig = { headers: { "Content-Type": "application/json" } };

export const createTemplate = async (name: string, query: unknown) =>
  caseTransformingAxios.post(
    `/listing_alert_templates`,
    JSON.stringify({ name, query }),
    preserveCaseConfig,
  );

export const updateTemplate = async (templateId: number, name: string, query: unknown) =>
  caseTransformingAxios.put(
    `/listing_alert_templates/${templateId}`,
    JSON.stringify({ name, query }),
    preserveCaseConfig,
  );

export const deleteTemplate = async (templateId: number): Promise<ServiceError> => {
  try {
    await caseTransformingAxios.delete(`/listing_alert_templates/${templateId}`);

    return { error: "" };
  } catch (e) {
    return createError(e);
  }
};
